import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import './App.css';
import SignInScreen from './auth/SignIn.js';
import Dashboard from './appContainer/views/dashboard/Dashboard.js';
import PrivacyPolicy from './appContainer/layout/footer/PrivacyPolicy.js';
import TermsOfService from './appContainer/layout/footer/TermsOfService.js';
import Header from './appContainer/layout/header/Header.js';
import NavDrawer from './appContainer/layout/nav/NavDrawer';
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import { withStyles } from "@material-ui/styles";
import { styles } from "./appContainer/layout/Layout.styles";
import { theme } from "./appContainer/layout/Layout.theme";
import Admin from './appContainer/views/admin/Admin';
import DevoteeContainer from "./appContainer/views/devotees/DevoteeContainer";
import ParticipationContainer from "./appContainer/views/participation/ParticipationContainer";
import DevotionalGroupsContainer
  from "./appContainer/views/devotionalGroups/DevotionalGroupsContainer";
import clsx from "clsx";
import connect from "react-redux/es/connect/connect";
import {
  initializeApp,
  setIsAuthorized,
  setIsAuthenticated,
  setIsInitialLoading,
} from "./redux/Redux.actions";

import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";

function PrivateRoute ({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        authed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/signIn",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}

function PublicRoute ({component: Component, path, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => {
        return authed === false
          ? <Component {...props} />
          : <Redirect to={`/`}/>
      }
      }
    />
  )
}

const mapStateToProps = state => ({
  isNavDrawerOpen: state.views.isNavDrawerOpen,
  isAuthorized: state.views.isAuthorized,
  isAuthenticated: state.views.isAuthenticated,
  isInitialLoading: state.views.isInitialLoading,
  devotees: state.firestore.data.devotees,
});

const mapDispatchToProps = dispatch => ({
  dispatchInitializeApp: val => dispatch(initializeApp(val)),
  dispatchSetIsAuthorized: val => dispatch(setIsAuthorized(val)),
  dispatchSetIsAuthenticated: val => dispatch(setIsAuthenticated(val)),
  dispatchSetIsInitialLoading: val => dispatch(setIsInitialLoading(val)),
});

class AppRouting extends React.Component {
  getCollections() {
    const { firestore } = this.props;
    firestore.get('devotees');
    firestore.get('devotionalGroups');
    firestore.get('events');
    firestore.get('attendances');
  }

  componentDidMount () {
    this.getCollections();
    this.removeListener = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.props.dispatchInitializeApp(user.email);
      } else {
        this.props.dispatchSetIsAuthorized(false);
        this.props.dispatchSetIsAuthenticated(false);
      }
    })
  }

  componentWillUnmount () {
    this.props.dispatchSetIsAuthorized(false);
    this.props.dispatchSetIsAuthenticated(false);
    this.props.dispatchSetIsInitialLoading(true);
    this.removeListener();
  }

  render() {
    const {
      classes,
      isNavDrawerOpen,
      isAuthorized,
      isAuthenticated,
    } = this.props;
    const isAuthed = isAuthenticated && isAuthorized;
    const mainClasses = isNavDrawerOpen ? classes.contentDrawerOpen : classes.content;

    return (
      <Router>
        <div className="App">
          <div className={classes.root}>
            {isAuthed && <CssBaseline/>}
            {isAuthed && <Header/>}
            {isAuthed && <NavDrawer/>}
            <main
              className={clsx(mainClasses)}
            >
              <Switch>
                <PublicRoute authed={isAuthed} path='/signIn' component={SignInScreen} />
                <PublicRoute authed={isAuthed} path='/privacy' component={PrivacyPolicy} />
                <PublicRoute authed={isAuthed} path='/tos' component={TermsOfService} />
                <PrivateRoute
                  path='/devotees'
                  component={DevoteeContainer}
                  authed={isAuthed}
                />
                <PrivateRoute
                  path='/admin'
                  component={Admin}
                  authed={isAuthed}
                />
                <PrivateRoute
                  component={DevotionalGroupsContainer}
                  path='/devotionalGroups'
                  authed={isAuthed}
                />
                <PrivateRoute
                  component={ParticipationContainer}
                  path='/participation'
                  authed={isAuthed}
                />
                <PrivateRoute
                  component={Dashboard}
                  path='/'
                  authed={isAuthed}
                />
              </Switch>
            </main>
          </div>
        </div>
      </Router>
    );
  }
}

export default compose(
  firestoreConnect(['devotionalGroups', 'devotees']),
  connect(mapStateToProps, mapDispatchToProps)
)(
  withStyles(
    styles,
    {
      defaultTheme: theme,
      withTheme: true,
      name: 'layout',
    }
  )(AppRouting));
